export enum EditorInputMenuItem {
    Bold = 'bold',
    Italic = 'italic',
    Strike = 'strike',
    Underline = 'underline',
    BulletList = 'bulletList',
    Link = 'link',
}
